import React, { Fragment } from "react";
import { Box, Card, Tooltip, Typography } from "@mui/material";
import { CollabRequests } from "../../admin/adminHomePage/CollabRequests";
import { GenericFlag } from "../../../components/generic/GenericFlag";
import { COUNTRIES_WITH_ISO } from "../../../enums/countries";
import { usePage } from "@inertiajs/react";
import { PENDING } from "../../../enums/statusEnums";

const CreatorCollabRequests = () => {
  const { auth } = usePage().props;

  const additionalColumns = [
    {
      field: 'country',
      headerName: 'Country',
      flex: 0.8,
      renderCell: ({ row }) => {
        return (
          <Tooltip title={row?.requested_by?.details?.country}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <GenericFlag code={COUNTRIES_WITH_ISO?.[row?.requested_by?.details?.country]} />
            </Box>
          </Tooltip>
        )
      },
      editable: false,
      sortable: false,
      resizable: false
    }
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Collab Requests</Typography>
      <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', padding: 2 }}>
        <CollabRequests
          title={'Incoming Collab Requests'}
          subTitle={'You have new requests from creators interested in collaborating with you. Review the details and decide who you’d like to work with.'}
          showHeader={false}
          additionalColumns={additionalColumns}
          additionalProps={{ status: PENDING, per_page: 10, user_id: auth?.user?.id }}
        />
      </Card>
    </Box>
  );
};

export default CreatorCollabRequests;